// Competition days follow Riyadh time (UTC+3, no daylight saving), like the
// server's PUSH_TZ. The end date is the last bookable moment of the chosen day,
// so every reader (status job, "ends tomorrow" push, beneficiary queries)
// can keep comparing `now <= endDate` (namat#33).
const RIYADH_OFFSET_MS = 3 * 60 * 60 * 1000;

export function competitionEndInstant(picked: Date): Date {
  const riyadh = new Date(picked.getTime() + RIYADH_OFFSET_MS);
  return new Date(
    Date.UTC(riyadh.getUTCFullYear(), riyadh.getUTCMonth(), riyadh.getUTCDate(), 23, 59, 59, 999) - RIYADH_OFFSET_MS,
  );
}

/** The Riyadh calendar day of an instant, as the `yyyy-MM-dd` logs use. */
export function riyadhDateKey(instant: Date): string {
  return new Date(instant.getTime() + RIYADH_OFFSET_MS).toISOString().slice(0, 10);
}

export interface CompetitionWindow {
  startDate: Date;
  endDate: Date;
}

/**
 * Whether a competitionsLogs entry (its `date`, `yyyy-MM-dd`) falls within the
 * competition's CURRENT start..end days (namat#34). Counts are derived from
 * the logs on every read, so moving the start date later restarts every
 * counter from that day — and moving it back restores them; nothing is
 * deleted. A log without a date is kept (legacy, never written today).
 */
export function isLogInCompetitionWindow(logDate: string | undefined, window: CompetitionWindow): boolean {
  if (!logDate) return true;
  return logDate >= riyadhDateKey(window.startDate) && logDate <= riyadhDateKey(window.endDate);
}

/** How many Riyadh calendar days a competition runs, first and last day included. */
export function competitionDayCount(window: CompetitionWindow): number {
  const first = Date.parse(riyadhDateKey(window.startDate));
  const last = Date.parse(riyadhDateKey(window.endDate));
  return Math.max(1, Math.round((last - first) / 86_400_000) + 1);
}
